import React, { useState, useEffect, lazy, Suspense } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Sidebar from '../components/layout/Sidebar';

// Pages
import AIStoryboard from './AIStoryboard';
import AIContentTools from './AIContentTools';
import AIVideoCreator from './AIVideoCreator';
import ImageUpscaler from './ImageUpscaler';
import AudioAnalysis from './AudioAnalysis';
import ContentSummarize from './ContentSummarize';
import './AILayout.css';

// Studio Pages (lazy loaded)
const StudioHome = lazy(() => import('./studio/StudioHome'));
const StudioNew = lazy(() => import('./studio/StudioNew'));
const StudioEditor = lazy(() => import('./studio/StudioEditor'));

const AILayout = () => {
  const location = useLocation();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // 모바일 메뉴 토글
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  // 모바일 메뉴 닫기
  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  // 라우트 변경 시 모바일 메뉴 닫기
  useEffect(() => {
    closeMobileMenu();
  }, [location.pathname]);

  // 모바일 메뉴 열릴 때 배경 스크롤 방지
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileMenuOpen]);

  return (
    <div className="ai-page-layout">
      {/* 모바일 오버레이 */}
      {mobileMenuOpen && (
        <div className="mobile-sidebar-overlay" onClick={closeMobileMenu} />
      )}

      <Sidebar
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
        mobileOpen={mobileMenuOpen}
        onMobileClose={closeMobileMenu}
      />

      <main className="ai-page-content">
        {/* 모바일 헤더 */}
        <div className="mobile-content-header">
          <button
            className="mobile-menu-toggle"
            onClick={toggleMobileMenu}
            aria-label="메뉴 열기"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <span className="mobile-page-title">AI Tools</span>
        </div>

        <Routes>
          <Route path="/" element={<AIContentTools />} />
          <Route path="/content-tools" element={<AIContentTools />} />
          <Route path="/storyboard" element={<AIStoryboard />} />
          <Route path="/video-creator" element={<AIVideoCreator />} />
          <Route path="/upscaler" element={<ImageUpscaler />} />
          <Route path="/audio-analysis" element={<AudioAnalysis />} />
          <Route path="/content-summarize" element={<ContentSummarize />} />
          <Route path="/summarize" element={<Navigate to="/content-summarize" replace />} />
          <Route path="/studio" element={<Suspense fallback={<div className="flex items-center justify-center h-full text-gray-400">로딩 중...</div>}><StudioHome /></Suspense>} />
          <Route path="/studio/new" element={<Suspense fallback={<div className="flex items-center justify-center h-full text-gray-400">로딩 중...</div>}><StudioNew /></Suspense>} />
          <Route path="/studio/editor/:id" element={<Suspense fallback={<div className="flex items-center justify-center h-full text-gray-400">로딩 중...</div>}><StudioEditor /></Suspense>} />
        </Routes>
      </main>
    </div>
  );
};

export default AILayout;
